module.exports = __webpack_public_path__ + "img/han_jie_gong_zuo_zhan4.f0a80d7c.png";